import React from 'react';
import PropTypes from 'prop-types';
import {FormattedRelative} from 'react-intl';
import FloatingActionButton from 'material-ui/FloatingActionButton';
import RefreshIcon from 'material-ui/svg-icons/navigation/refresh';

const RefreshHeader = (props) => {

    const {loadedTime, header, onTouchTap} = props;

    return (
        <div className="row">

            <div
                className="col s2"
                style={{
                paddingRight: '0',
                paddingLeft: '0'
            }}>
                <FloatingActionButton mini={true} onTouchTap={onTouchTap}>
                    <RefreshIcon/>

                </FloatingActionButton>
            </div>
            <div
                className="col s10"
                style={{
                paddingLeft: '0'
            }}>
                <h5>{header}
                    <small
                        style={{
                        paddingLeft: '10px',
                        fontSize: '.75rem'
                    }}>
                        Last Updated &nbsp;
                        <FormattedRelative value={loadedTime || new Date()}/></small>
                </h5>
            </div>

        </div>
    );

};

RefreshHeader.defaultProps = {
    headerStyle: {
        paddingTop: '5px',
        width: '100%',
        height: '60px'
    }
};

RefreshHeader.propTypes = {
    header: PropTypes.string,
    loadedTime: PropTypes.instanceOf(Date),
    onTouchTap: PropTypes.func
};

export default RefreshHeader;


// WEBPACK FOOTER //
// ./src/components/layout/RefreshHeader.js